import React from 'react';

const ProtectedEmail = ({ className = '', showText = true, linkOnly = false, style = {}, onMouseEnter, onMouseLeave, asButton = false }) => {
  // Obfuscated email parts
  const user = 'support';
  const domain = 'flumberico.fun';
  
  // Construct email on client-side
  const email = `${user}@${domain}`;
  
  // Render as text only (for schema - not clickable)
  if (linkOnly === 'schema') {
    return email;
  }
  
  // Render as plain text
  if (linkOnly === 'text') {
    return <span className={className}>{email}</span>;
  }
  
  // Render as button with hover handlers
  if (asButton) {
    return (
      <button
        onClick={() => window.location.href = `mailto:${email}`}
        className={className}
        style={style}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
        aria-label="Email FLUMBERICO support"
      >
        {showText ? email : 'Contact Us'}
      </button>
    );
  }
  
  // Render as clickable mailto link
  return (
    <a 
      href={`mailto:${email}`}
      className={className}
      style={style}
      onClick={(e) => {
        // Additional layer: construct href on click
        e.preventDefault();
        window.location.href = `mailto:${email}`;
      }}
    >
      {showText ? email : 'Contact Us'}
    </a>
  );
};

export default ProtectedEmail;
